import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import { getIn } from 'formik';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import { createStyles } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = createStyles(theme => ({
  wrapper: {
    display: 'flex',
    margin: `0 ${theme.spacing(2)}px`,
    alignSelf: 'center',
    alignItems: 'flex-start',
    width: 220,
  },
  label: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    margin: 0,
  },
  formGroup: {
    width: '100%',
  },
  labelRoot: {
    minWidth: 220,
  },
}));

class CommonCheckbox extends Component {
  
  static defaultProps = {
    disabled: false,
  };
  
  render() {
    const {
      field: { value, name },
      form,
      center,
      classes,
      validate,
      isSubmitted,
      label,
      helperText,
      disabled,
      isUpdate,
      setDirty,
      extraHandleChangeAction,
      ...rest
    } = this.props;
  
    const touched = getIn(form.touched, name) || isSubmitted;
    const error = getIn(form.errors, name);
  
    const componentMeta = form.getFieldMeta(name);
    const isUpdated = (componentMeta.initialValue !== componentMeta.value) && form.dirty;
  
    if (isUpdated && form.dirty && setDirty) setDirty(true);
  
    return (
      <FormControl className={`${classes.wrapper} CommonCheckboxWrapper`}>
        <FormGroup
          className={classes.formGroup}
          style={{
            justifyContent: center ? 'center' : '',
            flexDirection: 'row',
          }}>
          <FormControlLabel
            {...rest}
            classes={{ root: classes.labelRoot, label: classes.label }}
            control={
              <Checkbox
                checked={Boolean(value)}
                onChange={(event, value) => {
                  form.setFieldValue(name, value);
                  if (extraHandleChangeAction) {
                    extraHandleChangeAction();
                  }
                }}
                validate={validate}
                disabled={disabled}
              />}
            label={label}
          />
        </FormGroup>
        {touched && error &&
        <FormHelperText style={{ margin: '0 0 0 12px' }} error={touched && error}>{error}</FormHelperText>
        }
        {!(touched && error) && helperText &&
        <FormHelperText>{helperText}</FormHelperText>
        }
      </FormControl>
    );
  }
}

export default withStyles(styles)(CommonCheckbox);